export default __webpack_public_path__ + "static/media/1590.fea9e2b2.png";